import { render, staticRenderFns } from "./FormFileSignature.vue?vue&type=template&id=b1bc9edc&"
import script from "./FormFileSignature.vue?vue&type=script&lang=js&"
export * from "./FormFileSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports